module.exports = __webpack_public_path__ + "static/media/icon-pen-tool.e6eb6671.svg";